<template>
  <div class="cashback-purchase-container">
    <quark-shopping-cashback
      ref="cashbackRef"
      :key="cashbackKey"
      page-id="Welfare"
      scene-name-en="platform_points"
      sub-scene-name-en="pp_order_coin_back"
      :env="mobileEnv"
      scene="rebateBonus"
      auxo-grid-module-key="welfare"
      :use-cache="false"
      style-version="new_task_scene_v2"
      @emitevent="handleEmit"
    >
      <div
        slot="header"
        class="cashback-purchase-header"
      >
        <div class="header-left">
          <img
            class="title-logo"
            src="https://m.hellobike.com/resource/gallery/919/sLqi6vwcFr.png"
            alt=""
          >
          <div
            class="use-guide"
            @click="handleUseGuideClick"
          >
            <img
              class="coin-logo"
              src="https://m.hellobike.com/resource/gallery/833/8TcECPUAyI.png"
              alt=""
            >
            <span class="text">≈实付</span>
            <span class="num">x30</span>
            <img
              class="arrow-icon"
              src="https://m.hellobike.com/resource/gallery/833/yYWRfcHBXs.png"
              alt=""
            >
          </div>
        </div>
        <div class="header-right">
          <div
            class="order-btn"
            @click="handleOrderClick"
          >
            <span>我的订单</span>
            <img
              class="arrow-icon"
              src="https://m.hellobike.com/resource/gallery/3/YsSIswNW_title-info.png"
              alt=""
            >
          </div>
        </div>
      </div>
      <div
        slot="banner"
        class="cashback-purchase-banner"
      >
        <template v-if="rakeBackModuleInfo.isShow && !countDownEnd">
          <new-customer-reward
            v-if="rakeBackModuleInfo.bannerActivityTask"
            v-flash="{ hide: !showFlash, time: 4000 }"
            class="operation-area"
            :info="rakeBackModuleInfo.bannerActivityTask"
            @countDownEnd="handleCountDownEnd"
            @btnClick="handleNewBannerClick"
          />
        </template>
        <template v-else>
          <cashback-banner
            v-if="rakeBackModuleInfo.isShowBannerList"
            v-flash="{ hide: !showFlash, time: 4000 }"
            class="operation-area"
            :title="rakeBackModuleInfo.text"
            :list="rakeBackModuleInfo.bannerList"
            @bannerClick="handleBannerClick"
          />
        </template>
        <div class="middle-title">
          <div class="title-name">
            点击跳转平台，消费返币
          </div>
          <!-- <div class="title-desc">
            <span>点击跳转平台，下单返</span>
          </div> -->
        </div>
      </div>
      <div
        slot="clipboardTitle"
        class="cashback-purchase-clipboard-title"
      >
        <div class="middle-title">
          <div class="title-name">
            复制商品链接，消费返币
          </div>
          <!-- <div class="title-desc">
            <img
              v-for="item in channelList"
              :key="item.key"
              class="channel-icon"
              :src="item.icon"
              alt=""
            >
            <span class="channel-tips">淘宝 京东</span>
          </div> -->
        </div>
      </div>
    </quark-shopping-cashback>
    <!-- 使用指引 -->
    <div class="cashback-purchase-guide">
      <img
        class="guide-img"
        src="https://m.hellobike.com/c145d106_Group%201707483363.png"
        alt=""
      >
    </div>

    <!-- 新人首单引导弹窗 -->
    <new-user-popup
      :visible="newUserPopupVisible"
      :info="newUserPopupInfo"
      :popup-key="popupWindowKey"
      @close="handleNewUserPopupClose"
      @btnClick="handleNewUserPopupClick"
    />
  </div>
</template>

<script>
import eventBus from '@/const/eventBus';
import { jumpUrl } from '@/utils/tools';
import '@hb/generate-income-components';
import config from '@/const/config';
import SPM from '../common/spm';
import CashbackBanner from './cashback-banner';
import NewCustomerReward from './new-customer-reward';
import NewUserPopup from './new-user-popup';
import { POPUP_WINDOW_KEY } from '../consts';

export default {
  name: 'CashbackPurchase',
  components: {
    CashbackBanner,
    NewCustomerReward,
    NewUserPopup,
  },
  props: {
    // 电商返佣模块信息
    rakeBackModuleInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 设备环境
      mobileEnv: config.env === 'dev' ? 'fat' : config.env,
      // 倒计时是否结束
      countDownEnd: false,
      // 新人首单引导弹窗是否展示
      newUserPopupVisible: false,
      // 新人首单引导弹窗信息
      newUserPopupInfo: {},
      // 新人首单引导弹窗类型
      popupWindowKey: '',
      // 是否展示动画
      showFlash: false,
      // 购物反币渠道icon列表
      channelList: [
        {
          key: '淘宝',
          icon: 'https://m.hellobike.com/f00578cf_FuNftpjONLnPClmbds8dZRT70GbF_2.png',
        },
        {
          key: '京东',
          icon: 'https://m.hellobike.com/a05b7ab5e9.png',
        },
      ],
      // 用于 keep-alive 重新激活时强制刷新 Web Component 的 slot
      cashbackKey: 0,
    };
  },
  inject: ['popupWindowInfo'],
  computed: {
    // 是否应该触发新人首单引导弹窗
    shouldTriggerNewUserPopup() {
      const { showPopup } = this.rakeBackModuleInfo || {};
      const popupInfo = this.popupWindowInfo() || {};
      return !!(showPopup && popupInfo.key);
    },
  },
  watch: {
    shouldTriggerNewUserPopup(shouldTrigger) {
      if (shouldTrigger) {
        this.handleNewUserPopup();
      }
    },
  },
  activated() {
    // keep-alive 重新激活时，强制刷新 Web Component 以恢复 slot 渲染
    this.cashbackKey += 1;
  },
  mounted() {
    // 处理新人首单引导弹窗
    // this.handleNewUserPopup();
    // 处理玩法引导动画结束
    eventBus.$on('playGuideFinished', () => {
      this.showFlash = true;
    });
    SPM.moduleExpose({
      moduleId: 'platform_onlineretailers_return30',
      contentId: 'platform_onlineretailers_return30',
      businessInfo: {},
    });
  },
  methods: {
    // 处理倒计时结束
    handleCountDownEnd() {
      this.countDownEnd = true;
    },
    // 处理组件事件
    handleEmit(e) {
      if (e.detail.type === 'loaded') {
        this.$emit('loaded');
        return;
      }
      if (e.detail.type === 'cashback') {
        this.$emit('bounty');
      }
      if (e.detail.type === 'order') {
        this.handleOrderClick();
      }
    },
    // 跳转订单页
    handleOrderClick() {
      const url = `https://m.hellobike.com/AppCommercialH5/${
        this.mobileEnv !== 'pro' ? `${this.mobileEnv}/` : ''
      }latest/index.html#/myorder?scene=rebateBonus`;
      jumpUrl(url);

      // 订单点击埋点
      SPM.clickButton({
        buttonName: 'Welfare_onlineretailers_myorder',
        businessInfo: {},
      });
    },
    // 跳转使用指南
    handleUseGuideClick() {
      SPM.clickButton({
        buttonName: 'platform_onlineretailers_return30',
        businessInfo: {},
      });
      jumpUrl(
        'https://m.hellobike.com/mf/spa/u_xkyjzd/latest/MA2504087308769061950390860.html?activityCode=MA2504087308769061950390860',
      );
      // 教程点击埋点
      SPM.clickButton({
        buttonName: 'Welfare_onlineretailers_jiaocheng',
        businessInfo: {},
      });
    },
    // banner点击跳转
    handleBannerClick(item) {
      this.handleExternalJump(item);
    },
    // 外部跳转
    handleExternalJump(item) {
      const { cashbackRef } = this.$refs || {};
      if (cashbackRef && cashbackRef.channelClick) {
        cashbackRef.channelClick(item);
      }
    },
    // 新banner点击跳转
    handleNewBannerClick() {
      const { bannerActivityTask } = this.rakeBackModuleInfo;
      this.handleExternalJump(bannerActivityTask);
    },
    // 读取剪贴板
    readClipboard() {
      const { cashbackRef } = this.$refs || {};
      if (cashbackRef && cashbackRef.readClipboard) {
        cashbackRef.readClipboard();
      }
    },
    // 处理新人首单引导弹窗
    handleNewUserPopup() {
      const { key, data } = this.popupWindowInfo() || {};
      if (!data) return;
      if (
        key === POPUP_WINDOW_KEY.beginner_order_window
        || key === POPUP_WINDOW_KEY.beginner_order_window_v2
      ) {
        this.popupWindowKey = key;
        this.newUserPopupInfo = data;
        setTimeout(() => {
          this.newUserPopupVisible = true;
        }, 200);
      }
    },
    // 处理新人首单引导弹窗关闭
    handleNewUserPopupClose() {
      this.newUserPopupVisible = false;
    },
    // 处理新人首单引导弹窗按钮点击
    handleNewUserPopupClick() {
      this.handleExternalJump(this.newUserPopupInfo);
      this.newUserPopupVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.cashback-purchase-container {
  background-color: #fff;
  border-radius: 0.12rem;

  .shoppingCashbackContainer {
    padding: 0.16rem !important;
  }

  .middle-title {
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 0.12rem;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: 0.04rem;
      height: 0.12rem;
      border-radius: 0.02rem;
      background-color: #fd6532;
    }

    .title-name {
      font-weight: 700;
      font-size: 0.14rem;
      line-height: 0.2rem;
    }

    .title-desc {
      display: flex;
      align-items: center;
      margin-left: 0.08rem;
      font-size: 0.12rem;
      color: #879099;
    }

    .channel-icon {
      display: block;
      width: 0.19rem;
      height: 0.19rem;
      margin-left: -0.05rem;

      &:first-child {
        margin-left: 0;
      }
    }

    .channel-tips {
      margin-left: 0.03rem;
    }

    .desc-icon {
      margin-right: 0.04rem;
      width: 0.2rem;
      height: 0.2rem;
      vertical-align: bottom;
    }
  }
}

.cashback-purchase-header {
  display: flex;
  justify-content: space-between;

  .header-left {
    display: flex;
    align-items: center;

    .title-logo {
      height: 0.22rem;
    }

    .use-guide {
      display: flex;
      align-items: center;
      margin-left: 0.04rem;
      padding-right: 0.03rem;
      height: 0.16rem;
      border-radius: 0.16rem;
      background-color: #fff8da;
      font-weight: 600;
      font-size: 0.11rem;
      line-height: normal;
      color: #ff3e36;

      .text {
        flex-shrink: 0;
      }

      .num {
        font-family: 'DIN Alternate Bold', sans-serif;
      }
    }

    .coin-logo {
      margin-right: 0.02rem;
      width: 0.16rem;
      height: 0.16rem;
      vertical-align: bottom;
    }

    .arrow-icon {
      width: 0.1rem;
      height: 0.1rem;
      vertical-align: bottom;
    }
  }

  .header-right {
    display: flex;
    align-items: center;

    .order-btn {
      display: flex;
      align-items: center;
      font-size: 0.13rem;
      line-height: 0.17rem;
      color: #5a6066;
    }

    .arrow-icon {
      width: 0.12rem;
      height: 0.12rem;
      vertical-align: bottom;
    }
  }
}

.cashback-purchase-banner {
  margin-top: 0.08rem;

  .operation-area {
    margin-bottom: 0.08rem;
  }

  .operation-banner-area {
    display: flex;
    justify-content: center;
    width: 100%;
  }
}

.cashback-purchase-clipboard-title {
  .middle-title {
    margin-top: 0.1rem;
  }
}

.cashback-purchase-guide {
  margin-top: -0.08rem;
  padding: 0 0.12rem 0.12rem;

  .guide-img {
    width: 100%;
    height: 0.42rem;
    vertical-align: bottom;
  }
}
</style>
